<template>
  <div class="log-list">
    <el-form
      :inline="true"
      class="demo-form-inline"
      v-loading="loading"
      size="mini"
    >
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add" size="mini">新增</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="form.id ? '修改工作类别' : '新增工作类别'"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form">
        <el-form-item label="工作类别名称">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.priority" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="类目图片" prop="image">
          <el-upload
            action="https://up-z1.qbox.me/"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :data="uploadData"
          >
            <img v-if="form.image" :src="form.image" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <el-input type="hidden" v-model="form.image"></el-input>
          </el-upload>
          <p>图片比例为1:1</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDialogForm">取 消</el-button>
        <el-button type="primary" @click="addWorkCate">确 定</el-button>
      </div>
    </el-dialog>
    <el-table
      :data="tableData"
      style="width: 100%"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <el-table-column prop="id" label="序号" sortable width="180">
      </el-table-column>
      <el-table-column prop="name" label="工作类别" sortable width="180">
      </el-table-column>
      <el-table-column prop="priority" label="排序" sortable width="180">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleBan(scope.$index, scope.row, true)"
              v-if="scope.row.status == 1"
              >禁用</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="handleBan(scope.$index, scope.row, false)"
              v-if="scope.row.status == 0"
              >启用</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="handleBen(scope.$index, scope.row, false)"
              v-if="scope.row.ifShow == 0"
              :disabled="scope.row.status == 0"
              >展示到list</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleBen(scope.$index, scope.row, true)"
              v-if="scope.row.ifShow == 1"
              :disabled="scope.row.status == 0"
              >取消list展示</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="showInCategory(scope.row, 1)"
              v-if="scope.row.categoryShow == 0"
              :disabled="scope.row.status == 0"
              >类目页展示</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="showInCategory(scope.row, 0)"
              v-if="scope.row.categoryShow == 1"
              :disabled="scope.row.status == 0"
              >取消类目页展示</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../api";
const { workCateList, cate } = api;
export default {
  name: "workCate-list",
  data() {
    return {
      loading: true,
      tableData: [],
      form: {
        id: "",
        name: "",
        priority: 0,
        image: "",
      },
      dialogFormVisible: false,
      roles: [],
      total: 0,
      pageNum: 1,
      limit: 20,
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      let obj = {
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let res = await workCateList.list(obj);
      this.total = res.data.pageinfo.totalCount;
      this.tableData = res.data.data;
      this.loading = false;
    },
    async add() {
      this.dialogFormVisible = true;
      this.form.name = "";
      this.form.id = "";
      this.form.priority = 0;
      this.form.image = "";
    },
    async handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.form.name = row.name;
      this.form.id = row.id;
      this.form.priority = row.priority;
      this.form.image = row.image;
    },
    async handleBan(index, row, ifDelete) {
      let status = "";
      if (ifDelete) {
        status = "0";
      } else {
        status = "1";
      }
      const {
        data: { code },
      } = await workCateList.updateStatus({
        id: row.id,
        status: status,
      });
      if (code === 200) {
        this.fetch();
      }
    },
    async handleBen(index, row, ifDelete) {
      let ifShow = "";
      if (ifDelete) {
        ifShow = "0";
      } else {
        ifShow = "1";
      }
      let {
        data: { code },
      } = await workCateList.updateStatus({
        id: row.id,
        ifShow: ifShow,
      });
      if (code === 200) {
        this.fetch();
      }
    },
    async addWorkCate() {
      let {
        data: { code },
      } = await workCateList.save({
        id: this.form.id,
        name: this.form.name,
        parentId: 0,
        priority: this.form.priority,
        image: this.form.image,
      });
      if (code === 200) {
        if (this.form.id != "") {
          this.$message.success("修改成功");
        } else {
          this.$message.success("增加工作类别成功");
        }
        this.resetDialogForm();
      }
      this.fetch();
    },
    resetDialogForm() {
      this.form.name = "";
      this.form.id = "";
      this.dialogFormVisible = false;
    },
    async showInCategory(data, isShow) {
      // 切换在首页和类目页展示状态
      let obj = {
        id: data.id,
        categoryShow: isShow,
      };
      let {
        data: { code },
      } = await cate.showInCategory(obj);
      if (code == 200) {
        this.fetch();
      }
    },
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    handleSuccess(res, file) {
      this.form.image = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
    },
  },
  mounted() {
    this.fetch();
    this.getToken();
  },
};
</script>
<style>
.el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar {
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #ffffff;
  font-size: 20px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/cate/cates.vue